import { render, staticRenderFns } from "./CertificateCompletion.vue?vue&type=template&id=2c45371c"
import script from "./CertificateCompletion.vue?vue&type=script&lang=js"
export * from "./CertificateCompletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports